// Core
import React, { useState, useEffect } from 'react';
import {
  Card, Row, Col, Form, Input, Divider, Radio, notification
} from 'antd';
import { useSelector, useDispatch } from 'react-redux';
import { useParams, useHistory } from 'react-router-dom';

// App
import { PageHeader } from 'antd';
import { Button } from '../../../components/buttons/buttons';
import { Main } from '../../styled';
import { pacienteFichaMedicaCreateAction, pacienteFichaMedicaReadAction } from '../../../redux/clinica/pacientes/actionCreator';

const FichaMedicaView = ({ setSubmenu }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [form] = Form.useForm();
  const { id } = useParams();
  const registro = useSelector(state => state.PacienteReducer.fichaMedica);
  const isLoading = useSelector(state => state.responseReducer.loading);

  useEffect(() => {
    console.log('pacienteId: ', id);
    if (id) dispatch(pacienteFichaMedicaReadAction(id));
    else {
      dispatch(pacienteFichaMedicaReadAction());
      form.resetFields();
    }
  }, [id]);

  useEffect(() => {
    if (registro.id) {
      form.setFieldsValue(registro);
    } else {
      form.resetFields();
    }
  }, [form, registro]);

  const handleSubmit = async values => {
    console.log("values:", values);
    let action = 'create';
    if (id) {
      action = 'update';
    }
    const responseApi = await dispatch(
      pacienteFichaMedicaCreateAction({
        ...values,
        action: action,
      }),
    );
    if (responseApi) {
      let mensaje = 'Ficha medica del paciente creada exitosamente';
      if (action === 'update') mensaje = 'Ficha medica del paciente actualizada exitosamente';
      notification.success({
        message: mensaje,
      });
      form.resetFields();
      setSubmenu('main');
    } else {
      notification.error({
        message: 'Error al crear ficha medica de paciente',
      });
    }
  };

  return (
    <>
      <Card>
        <PageHeader
          onBack={() => history.replace(`/admin/clinica/pacientes/expediente/${id}`)}
          title="Ficha médica"
          subTitle="Diagnóstico general del paciente"
        />
        <Row gutter={24}>
          <Col lg={24} md={24} sm={24}>
            <Form
              layout="vertical"
              size="small"
              form={form}
              onFinish={handleSubmit}
            >
              <Divider orientation="left">Historial médico</Divider>

              <Form.Item
                name="motivos_consulta"
                label="¿Cuál es el motivo de la consulta?"
                rules={[{ message: 'Campo obligatorio', required: true }]}
              >
                <Input placeholder="" />
              </Form.Item>
              <Form.Item name="padece_enfermedad" label="¿Padece actualmente alguna enfermedad?"
                rules={[{ message: 'Campo obligatorio', required: true }]}>
                <Radio.Group>
                  <Radio value="0">
                    No
                  </Radio>
                  <Radio value="1">
                    Si
                  </Radio>
                </Radio.Group>
              </Form.Item>
              <Form.Item label="* ¿Ha estado hospitalizado alguna vez?">
                <Input.Group compact>
                  <Form.Item name="hospitalizado"
                    rules={[{ message: 'Campo obligatorio', required: true }]} noStyle>
                    <Radio.Group style={{ width: '200px', margin: '0 7px' }}>
                      <Radio value="0">
                        No
                      </Radio>
                      <Radio value="1">
                        Si
                      </Radio>
                    </Radio.Group>
                  </Form.Item>
                  <Form.Item
                    name="detalle_hospitalizado"
                    noStyle
                    rules={[{ required: false }]}
                  >
                    <Input placeholder="¿Porqué?" style={{ width: '600px' }} />
                  </Form.Item>

                </Input.Group>
              </Form.Item>
              <Form.Item label="* ¿Se encuentra bajo tratamiento médico?">
                <Input.Group compact>
                  <Form.Item name="bajo_tratamiento" noStyle
                    rules={[{ message: 'Campo obligatorio', required: true }]}>
                    <Radio.Group style={{ width: '200px', margin: '0 7px' }}>
                      <Radio value="0">
                        No
                      </Radio>
                      <Radio value="1">
                        Si
                      </Radio>
                    </Radio.Group>
                  </Form.Item>
                  <Form.Item
                    name="detalle_bajo_tratamiento"
                    noStyle
                    rules={[{ required: false }]}
                  >
                    <Input placeholder="¿Cuál?" style={{ width: '600px' }} />
                  </Form.Item>

                </Input.Group>
              </Form.Item>
              <Form.Item label="* ¿Toma algún medicamento o droga?">
                <Input.Group compact>
                  <Form.Item name="toma_medicamento" noStyle
                    rules={[{ message: 'Campo obligatorio', required: true }]}>
                    <Radio.Group style={{ width: '200px', margin: '0 7px' }}>
                      <Radio value="0">
                        No
                      </Radio>
                      <Radio value="1">
                        Si
                      </Radio>
                    </Radio.Group>
                  </Form.Item>
                  <Form.Item
                    name="detalle_toma_medicamento"
                    noStyle
                    rules={[{ required: false }]}
                  >
                    <Input placeholder="¿Cuál?" style={{ width: '600px' }} />
                  </Form.Item>
                </Input.Group>
              </Form.Item>
              <Form.Item label="* ¿Presenta algún tipo de alergia?">
                <Input.Group compact>
                  <Form.Item name="alergia" noStyle
                    rules={[{ message: 'Campo obligatorio', required: true }]}>
                    <Radio.Group style={{ width: '200px', margin: '0 7px' }}>
                      <Radio value="0">
                        No
                      </Radio>
                      <Radio value="1">
                        Si
                      </Radio>
                    </Radio.Group>
                  </Form.Item>
                  <Form.Item
                    name="detalle_alergia"
                    noStyle
                    rules={[{ required: false }]}
                  >
                    <Input placeholder="¿Cuál?" style={{ width: '600px' }} />
                  </Form.Item>

                </Input.Group>
              </Form.Item>

              <Form.Item label="* ¿Tiene reacciones a la anestesia dental?">
                <Input.Group compact>
                  <Form.Item name="reaccion_anestesia" noStyle
                    rules={[{ message: 'Campo obligatorio', required: true }]}>
                    <Radio.Group style={{ width: '200px', margin: '0 7px' }}>
                      <Radio value="0">
                        No
                      </Radio>
                      <Radio value="1">
                        Si
                      </Radio>
                    </Radio.Group>
                  </Form.Item>
                  <Form.Item
                    name="detalle_reaccion_anestesia"
                    noStyle
                    rules={[{ required: false }]}
                  >
                    <Input placeholder="¿Cuál?" style={{ width: '600px' }} />
                  </Form.Item>

                </Input.Group>
              </Form.Item>


              <Form.Item name="hemorragias" label="¿Padece hemorragias o sangrados?"
                rules={[{ message: 'Campo obligatorio', required: true }]}>
                <Radio.Group>
                  <Radio value="0">
                    No
                  </Radio>
                  <Radio value="1">
                    Si
                  </Radio>
                </Radio.Group>
              </Form.Item>
              <Form.Item
                name="malos_habitos"
                label="¿Malos habitos? (Chuparse el dedo, morderse las uñas, morder lápiz, etc)"
                rules={[{ required: false }]}
              >
                <Radio.Group>
                  <Radio value="0">
                    No
                  </Radio>
                  <Radio value="1">
                    Si
                  </Radio>
                </Radio.Group>
              </Form.Item>
              <Divider orientation='left'>¿Padece o ha padecido alguna de estas enfermedades?</Divider>
              <Form.Item
                name="diabetes"
                label="1. Diabetes"
                rules={[{ required: false }]}
              >
                <Radio.Group>
                  <Radio value="0">
                    No
                  </Radio>
                  <Radio value="1">
                    Si
                  </Radio>
                </Radio.Group>
              </Form.Item>
              <Form.Item
                name="anemia"
                label="2. Anemia"
                rules={[{ required: false }]}
              >
                <Radio.Group>
                  <Radio value="0">
                    No
                  </Radio>
                  <Radio value="1">
                    Si
                  </Radio>
                </Radio.Group>
              </Form.Item>
              <Form.Item
                name="problemas_cardiacos"
                label="3. Problemas cardiacos"
                rules={[{ required: false }]}
              >
                <Radio.Group>
                  <Radio value="0">
                    No
                  </Radio>
                  <Radio value="1">
                    Si
                  </Radio>
                </Radio.Group>
              </Form.Item>
              <Form.Item
                name="fiebre_reumatica"
                label="4. Fiebre reumática"
                rules={[{ required: false }]}
              >
                <Radio.Group>
                  <Radio value="0">
                    No
                  </Radio>
                  <Radio value="1">
                    Si
                  </Radio>
                </Radio.Group>
              </Form.Item>
              <Form.Item
                name="problemas_renales"
                label="5. Problemas renales"
                rules={[{ required: false }]}
              >
                <Radio.Group>
                  <Radio value="0">
                    No
                  </Radio>
                  <Radio value="1">
                    Si
                  </Radio>
                </Radio.Group>
              </Form.Item>
              <Form.Item
                name="hipertension"
                label="6. Hipo o hipertensión"
                rules={[{ required: false }]}
              >
                <Radio.Group>
                  <Radio value="0">
                    No
                  </Radio>
                  <Radio value="1">
                    Si
                  </Radio>
                </Radio.Group>
              </Form.Item>
              <Form.Item
                name="asma"
                label="7. Asma"
                rules={[{ required: false }]}
              >
                <Radio.Group>
                  <Radio value="0">
                    No
                  </Radio>
                  <Radio value="1">
                    Si
                  </Radio>
                </Radio.Group>
              </Form.Item>
              <Form.Item
                name="epilepsia"
                label="8. Epilepsia"
                rules={[{ required: false }]}
              >
                <Radio.Group>
                  <Radio value="0">
                    No
                  </Radio>
                  <Radio value="1">
                    Si
                  </Radio>
                </Radio.Group>
              </Form.Item>
              <Form.Item
                name="hepatitis"
                label="9. Hepatitis"
                rules={[{ required: false }]}
              >
                <Radio.Group>
                  <Radio value="0">
                    No
                  </Radio>
                  <Radio value="1">
                    Si
                  </Radio>
                </Radio.Group>
              </Form.Item>
              <Form.Item
                name="vih"
                label="10. VIH"
                rules={[{ required: false }]}
              >
                <Radio.Group>
                  <Radio value="0">
                    No
                  </Radio>
                  <Radio value="1">
                    Si
                  </Radio>
                </Radio.Group>
              </Form.Item>
              <Divider orientation="left">Estado periodontal</Divider>
              <Form.Item
                name="inflamacion_encias"
                label="1. Inflamación de encias"
                rules={[{ required: false }]}
              >
                <Radio.Group>
                  <Radio value="0">
                    No
                  </Radio>
                  <Radio value="1">
                    Si
                  </Radio>
                </Radio.Group>
              </Form.Item>
              <Form.Item
                name="sangrado_encias"
                label="2. Sangrado de encias"
                rules={[{ required: false }]}
              >
                <Radio.Group>
                  <Radio value="0">
                    No
                  </Radio>
                  <Radio value="1">
                    Si
                  </Radio>
                </Radio.Group>
              </Form.Item>
              <Form.Item
                name="mal_olor_boca"
                label="3. Mal olor en la boca"
                rules={[{ required: false }]}
              >
                <Radio.Group>
                  <Radio value="0">
                    No
                  </Radio>
                  <Radio value="1">
                    Si
                  </Radio>
                </Radio.Group>
              </Form.Item>
              <Divider orientation="left">Historial dental</Divider>
              <Form.Item
                name="dificultad_masticar"
                label="1. Dificultad al masticar"
                rules={[{ required: false }]}
              >
                <Radio.Group>
                  <Radio value="0">
                    No
                  </Radio>
                  <Radio value="1">
                    Si
                  </Radio>
                </Radio.Group>
              </Form.Item>
              <Form.Item
                name="dolor_dental"
                label="2. Dolor dental"
                rules={[{ required: false }]}
              >
                <Radio.Group>
                  <Radio value="0">
                    No
                  </Radio>
                  <Radio value="1">
                    Si
                  </Radio>
                </Radio.Group>
              </Form.Item>
              <Form.Item
                name="chasquidos"
                label="3. Chasquidos al abrir o cerrar la boca"
                rules={[{ required: false }]}
              >
                <Radio.Group>
                  <Radio value="0">
                    No
                  </Radio>
                  <Radio value="1">
                    Si
                  </Radio>
                </Radio.Group>
              </Form.Item>
              <br />
              <div className="record-form-actions text-right">
                <Button size="default" htmlType="Save" type="primary">
                  {isLoading ? 'Cargando...' : 'Guardar'}
                </Button>
              </div>

              <Form.Item name="id" initialValue="0">
                <Input hidden />
              </Form.Item>
              <Form.Item name="idPaciente" initialValue={id}>
                <Input hidden />
              </Form.Item>
            </Form>
          </Col>
        </Row>
      </Card>
    </>
  );
};

export default FichaMedicaView;
